import { render, staticRenderFns } from "./DocumentoIBPList.vue?vue&type=template&id=d1f5b518"
import script from "./DocumentoIBPList.vue?vue&type=script&lang=js"
export * from "./DocumentoIBPList.vue?vue&type=script&lang=js"
import style0 from "./DocumentoIBPList.vue?vue&type=style&index=0&id=d1f5b518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports